var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0ZM8 8V14H10V8H8ZM7.75 5C7.75 4.30964 8.30964 3.75 9 3.75C9.69036 3.75 10.25 4.30964 10.25 5C10.25 5.69036 9.69036 6.25 9 6.25C8.30964 6.25 7.75 5.69036 7.75 5Z","fill":"currentColor"}));
}

Info.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Info;

Info.default = Info;
